import { ApiService, GenericError } from './api-main'
import TokenService from './token-service'
import store            from '../store';

const StaticDataService = {

    getServiceTimes: async function() {
        const url = 'main/getServiceTimes/'+ process.env.VUE_APP_RETAIL_AGENT_ID
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, '3211')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getPublicHoliday: async function(countryId) {
        const url = 'main/ph/country/'+countryId

        const params = {daysInAdvance : 4}
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '4310')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getHelpText: async function(startId, endId) {
        ApiService.setCustomHeader(1, TokenService.getToken(), "");

        const url = 'main/helpText'

        const params = {
            id : startId,
            endId : endId,
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log(response)

            return ApiService.validateResponse(response, '4316')
        } catch(e) {
            console.log('error calling helptext api')
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getCountryList: async function() {
        const url = 'main/country'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            return ApiService.validateResponse(response, '1009')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    // DR-1845 (follow-up) - Beneficiary Country dropdown, pre-filtered against
    // opssystemconfiguration.BENEFICIARY_COUNTRY_EXCLUDE_LIST server-side.
    // Use this (not getCountryList above) for the Beneficiary Country field -
    // getCountryList stays unfiltered since it also backs the unrelated
    // Nationality dropdown.
    getBeneficiaryCountryList: async function() {
        const url = 'main/country/beneficiary'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            return ApiService.validateResponse(response, '5554')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    // DR-1845 - GeoNames city typeahead for the Beneficiary Town/City field,
    // scoped to the selected Beneficiary Country (server-side proxy).
    getCitySuggestions: async function(q, countryId) {
        const url = 'main/country/citysuggest'
        const params = { q: q, countryId: countryId }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '5552')
        } catch(e) {
            // DR-1845 code-inspection fix (Minor) - removed console.log(e); the
            // exception is already correctly re-thrown/handled below.
            if(e instanceof GenericError) {
                throw e
            }
            return [];
        }
    },

    getOccupationList: async function(occupation) {
        const url = 'main/occupation'
        try {
            const params = { occupationStr: occupation}
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '0429')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getIndustryList: async function(page) {
        const occParamMyInfo = store.state.myinfo.occupation == undefined ? "" : encodeURIComponent(store.state.myinfo.occupation)
        const occParamEkyc = store.state.customer.update.occupation == undefined ? "" : encodeURIComponent(store.state.customer.update.occupation)
        const occParam = page == "myinfo" ? occParamMyInfo : occParamEkyc

        const url = 'main/industry'
        try {
            const params = { occupation: occParam.trim()}
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            // console.log("getIndustryList (param occupation = "+occParam.trim()+") : ", response.data)
            return response.data; //ApiService.validateResponse(response, '0429')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getHelpTextById: async function(helpTextId, helpTextEndId) {
        const url = 'main/helpText'
        try {
            const params = { id: helpTextId, endId: helpTextEndId}
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '4316')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },
    getOnlineAdvisory: async function(countryId,langId) {
        const url = 'main/onlineadvisory/content/4/' + countryId+"/"+langId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, '1105');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
    getDeliveryTime: async function() {
        const url = 'main/deliverytime'
        try {
            const params = { raId: process.env.VUE_APP_RETAIL_AGENT_ID}
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, 'WN00432');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
}

export default StaticDataService